/**
 * Frame-gallery polling hook (T027). Like useJobLogs, it tracks the job status
 * from the `['job', id]` cache so it stops when the job is terminal.
 */
import {
  keepPreviousData,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query'
import { getFrames } from '../lib/endpoints/jobs'
import { qk } from '../lib/queryKeys'
import { isActive } from '../lib/jobStatus'
import type { Job } from '../lib/schemas'

export function useFrames(id: string, cursor?: string) {
  const qc = useQueryClient()
  return useQuery({
    queryKey: qk.frames(id),
    queryFn: () => getFrames(id, cursor),
    enabled: !!id,
    refetchInterval: () =>
      isActive(qc.getQueryData<Job>(qk.job(id))) ? 3000 : false,
    retry: 1,
    staleTime: 2500,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: true,
  })
}
